import { render } from "./FaqAdminModalCreate.pug?vue&type=template&id=0b2d9c34&lang=pug"
import script from "./FaqAdminModalCreate.js?vue&type=script&lang=js"
export * from "./FaqAdminModalCreate.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__